// extracted by mini-css-extract-plugin
export var fieldset = "styles-module--fieldset--1Vl_l";
export var icon = "styles-module--icon--1LwrB";
export var input = "styles-module--input--3-QXE";
export var item = "styles-module--item--VdMl-";
export var label = "styles-module--label--2yEQJ";
export var list = "styles-module--list--1ePXl";
export var panel = "styles-module--panel--NKNTh";
export var names = "styles-module--names--3rFw7";
export var button = "styles-module--button--3aLO2";